import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FloatingHelpButton from '../FloatingHelpButton/FloatingHelpButton';

function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet /> {/* This renders the child routes */}
      <Footer />
      <FloatingHelpButton />
    </>
  );
}

export default PublicLayout;
